import { Plus } from "lucide-react";
import { Reveal, Stagger, staggerItem } from "@/lib/reveal";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";

export const Conditions = () => {
  const { t } = useLanguage();
  const conditionsList = t.conditions.items || [];

  return (
    <section id="conditions" data-testid="conditions" className="py-24 md:py-32">
      <div className="container-x grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal className="overline font-bold tracking-[0.2em]">{t.conditions.overline}</Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-foreground leading-[1.1]">
              {t.conditions.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base sm:text-lg text-foreground/80 font-medium leading-relaxed max-w-sm">
              {t.conditions.desc}
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Stagger className="grid sm:grid-cols-2 border-t border-l border-border">
            {conditionsList.map((c) => (
              <motion.div
                key={c}
                variants={staggerItem}
                data-testid={`condition-${c}`}
                className="group flex items-center gap-4 border-r border-b border-border px-6 py-5 hover:bg-secondary transition-colors duration-300"
              >
                <span className="h-9 w-9 shrink-0 grid place-items-center rounded-sm border-2 border-border text-accent group-hover:bg-accent group-hover:text-white group-hover:border-accent transition-all font-bold">
                  <Plus size={18} strokeWidth={2.5} />
                </span>
                <span className="text-base font-bold text-foreground">{c}</span>
              </motion.div>
            ))}
          </Stagger>
        </div>
      </div>
    </section>
  );
};
